angular.module('TetherApp').controller('ExperienceController', [
    '$controller',
    '$mdDialog',
    '$mdToast',
    '$window',
    'experienceService',
    function (
        $controller,
        $mdDialog,
        $mdToast,
        $window,
        experienceService
    ) {
        let self = this;

        self.participantController = $controller('ParticipantController');

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };

        self.keysAllowed = [
            'address',
            'address_1',
            'address_2',
            'city',
            'postal',
            'province',
            'country',
            'name',
            'first_name',
            'last_name',
            'ribbon_customization_1',
            'ribbon_customization_2'
        ];

        //START: MODALS
        self.dataPopup = function (ev, experienceParticipantId, data) {
            self.experienceParticipantId = experienceParticipantId;
            self.data = typeof data === 'string' ? JSON.parse(data) : data;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'dataPopup',
                bindToController: true,
                templateUrl: '/experience/partials/data-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
        //END: MODALS

        self.dataPopupEnableEditing = function() {
            self.isEditingEnabled = !self.isEditingEnabled;
        };

        self.dataPopupUpdate = function() {
            experienceService.updateExperienceParticipant(
                self.experienceParticipantId,
                self.data
            )
                .then(
                    onDataPopupUpdate,
                    onError
                );
        };

        let onDataPopupUpdate = function (data) {
            self.dataPopupEnableEditing();
            return;
        };

        let onParticipantReset = function (data) {
            return;
        };

        let onError = function(reason) {
            return;
        };

        let ReprocessDialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.experienceId = self.reprocessDialogControllerExperienceId;
            dCtrl.confirmation = self.reprocessDialogControllerConfirmation;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            let onReprocess = function (data) {
                dCtrl.cancel();
                $mdToast.show({
                    hideDelay: 1500,
                    position: 'bottom left',
                    template: '<md-toast style="max-width: 340px;">' +
                        '<span class="md-toast-text"><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Successfully marked for reprocessing!</span>' +
                        '</md-toast>'
                });
            };


            dCtrl.reprocess = function () {
                experienceService.reprocess(dCtrl.experienceId, {
                    entry: dCtrl.confirmation,
                    suggested_credits: dCtrl.suggested_credits
                }).then(onReprocess, onError);
            }
        };

        self.reprocess = function (experienceId, confirmation) {
            self.reprocessDialogControllerExperienceId = experienceId;
            self.reprocessDialogControllerConfirmation = confirmation;
            ReprocessDialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ReprocessDialogController,
                controllerAs: 'reprocessConfirmationController',
                bindToController: true,
                templateUrl: '/experience/partials/reprocess-confirmation-pop-up',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        self.resetParticipant = function(participantId, experienceId) {
            if ($window.confirm(self.confirmResetParticipantText)) {
                experienceService.resetParticipant(
                    participantId,
                    self.type,
                    experienceId
                )
                    .then(onParticipantReset, onError);
            }
        };
    }
]);
